<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="users"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :sort="sort"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Уведомления</h1>
        <btn-filters
          :data="data"
          endpoint="users"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @sort-change="sortChange"
        @row-click="((row) => this.$router.push(`/settings/notifications/${row.id}`))"
      >
        <el-table-column sortable="keyword" prop="second_name" label="Фамилия"></el-table-column>
        <el-table-column sortable="keyword" prop="first_name" label="Имя"></el-table-column>
        <el-table-column sortable="keyword" prop="third_name" label="Отчество"></el-table-column>
        <el-table-column>
          <template slot-scope="{row}">
                <span v-if="row.notification_setting && row.notification_setting.event_codes_count>0"
                      class="text-danger">
                  Настроено уведомлений : {{row.notification_setting.event_codes_count}}
                </span>
            <span class="muted" v-else>Нет уведомлений</span>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="{row}">
            <template v-if="row.notification_setting">
              <span v-if="row.notification_setting.sms_count">
              <img src="~img/phone.svg">
                 : {{row.notification_setting.sms_count}}
              </span>
              <span v-if="row.notification_setting.email_count">
              <img src="~img/type2.svg">
                 : {{row.notification_setting.email_count}}
              </span>
            </template>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Уведомления'},
    data() {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        sort: null,
      }
    },
    methods: {
      sortChange(sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const keyword = sort.column.sortable === 'keyword' ? '.keyword' : ''
          this.sort = `${sort.prop + keyword}:${order}`
        } else {
          this.$emit('update:sort', null)
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/notifications/index.vue